/* Nancy double-upsell modal handler — loaded by layout */
(function () {
  if (window.__nancyDoubleHandlerInit) return;
  window.__nancyDoubleHandlerInit = true;

  function init(modal) {
    if (modal.__nancyDoubleInit) return;
    modal.__nancyDoubleInit = true;

    var section  = modal.closest('.shopify-section') || document;
    var img      = modal.querySelector('[data-pdp-double-img]');
    var nameEl   = modal.querySelector('[data-pdp-double-name]');
    var priceEl  = modal.querySelector('[data-pdp-double-price]');
    var addBtn   = modal.querySelector('[data-pdp-double-add]');
    var addLabel = modal.querySelector('[data-pdp-double-add-label]');
    var skipBtn  = modal.querySelector('[data-pdp-double-skip]');
    var addedEl  = modal.querySelector('[data-pdp-double-added]');
    var rotateEl = modal.querySelector('[data-pdp-double-rotate]');
    var swatches = modal.querySelectorAll('[data-pdp-double-swatch]');
    var closes   = modal.querySelectorAll('[data-pdp-double-close]');

    function defaultSwatch() {
      return modal.querySelector('[data-pdp-double-swatch].is-suggested') || swatches[0];
    }

    function setPanty(sw) {
      if (!sw) return;
      var pImg   = sw.getAttribute('data-product-image');
      var pName  = sw.getAttribute('data-product-title');
      var pPrice = sw.getAttribute('data-product-price');
      if (img)    { img.src = pImg; img.alt = pName; }
      if (nameEl) nameEl.textContent = pName;
      if (priceEl) priceEl.textContent = pPrice;
      if (addLabel) addLabel.textContent = '+ Add ' + pName;
      if (addBtn) {
        addBtn.setAttribute('data-variant-id', sw.getAttribute('data-variant-id'));
        addBtn.setAttribute('data-product-handle', sw.getAttribute('data-product-handle'));
      }
      Array.prototype.forEach.call(swatches, function (s) {
        var on = (s === sw);
        s.classList.toggle('is-suggested', on);
        s.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    if (rotateEl) {
      var rwords = (rotateEl.getAttribute('data-words') || 'spicier,hotter,kinkier,saucier').split(',');
      var ri = 0;
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        setInterval(function () {
          ri = (ri + 1) % rwords.length;
          rotateEl.style.opacity = '0';
          setTimeout(function () { rotateEl.textContent = rwords[ri]; rotateEl.style.opacity = '1'; }, 170);
        }, 1800);
      }
    }

    function openModal(plushieTitle) {
      if (addedEl && plushieTitle) addedEl.textContent = plushieTitle;
      setPanty(defaultSwatch());
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
    Array.prototype.forEach.call(closes, function (b) { b.addEventListener('click', closeModal); });

    Array.prototype.forEach.call(swatches, function (sw) {
      sw.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        setPanty(sw);
      });
    });

    if (skipBtn) {
      skipBtn.addEventListener('click', function () { window.location.href = '/cart'; });
    }
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var vid = addBtn.getAttribute('data-variant-id');
        if (!vid) { window.location.href = '/cart'; return; }
        addBtn.disabled = true;
        if (addLabel) addLabel.textContent = 'Adding…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: vid, quantity: 1 })
        }).then(function () {
          window.location.href = '/cart';
        }).catch(function () {
          addBtn.disabled = false;
          if (addLabel) addLabel.textContent = 'Try again';
        });
      });
    }

    modal.__nancyOpen = openModal;
  }

  // Init all modals already in the DOM
  function bootstrap() {
    document.querySelectorAll('[data-pdp-double-modal]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootstrap);
  else bootstrap();

  // Global click interceptor for the addon_plushies primary button
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-pdp-addons-double]');
    if (!btn) return;
    var sec   = btn.closest('.shopify-section');
    var modal = sec ? sec.querySelector('[data-pdp-double-modal]') : null;
    if (!modal) return;
    // Ensure modal is initialized (in case DOM was added later)
    if (!modal.__nancyDoubleInit) init(modal);
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
    var vid = btn.getAttribute('data-variant-id');
    var title = btn.getAttribute('data-product-title');
    if (!vid) return;
    var origLabel = btn.querySelector('[data-pdp-addons-btn-label]');
    var origText  = origLabel ? origLabel.textContent : '';
    if (origLabel) origLabel.textContent = 'Adding…';
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: vid, quantity: 1 })
    }).then(function () {
      btn.disabled = false;
      if (origLabel) origLabel.textContent = origText;
      if (modal.__nancyOpen) modal.__nancyOpen(title);
      else modal.classList.add('is-open');
    }).catch(function () {
      btn.disabled = false;
      if (origLabel) origLabel.textContent = origText;
    });
  }, true);
})();
